var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.background.length === 0)?_c('div',{staticClass:"label",class:( _obj = {}, _obj['bg-'+_vm.color] = _vm.color, _obj )},[_vm._t("default")],2):_c('div',{staticClass:"label",style:({backgroundColor: _vm.background})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }